import { memo } from 'react';

import { PROFILE_ICONS } from '@/features/profile/constants/icons';
import {
  ProgressCircleIndicator,
  type ProgressCircleIndicatorProps,
} from '@/shared/components/progressCircleIndicator';

export interface ProfileVibeIndicatorProps extends Omit<
  ProgressCircleIndicatorProps,
  'icon' | 'progress'
> {
  progress: number;
  showLabel?: boolean;
}

export const ProfileVibeIndicator = memo(function ProfileVibeIndicator({
  progress,
  showLabel,
  ...props
}: ProfileVibeIndicatorProps) {
  const VibeIcon = PROFILE_ICONS.vibe;

  const indicator = (
    <ProgressCircleIndicator
      progress={progress}
      icon={<VibeIcon className="size-7" />}
      {...props}
    />
  );

  if (!showLabel) {
    return indicator;
  }

  return (
    <div className="flex items-center gap-2">
      {indicator}
      <div className="flex w-14 flex-col items-start">
        <span className="text-cold-100 text-sm font-bold">Vibe</span>
        <span className="text-cold-300 text-xs font-medium">
          {Math.round(progress)}%
        </span>
      </div>
    </div>
  );
});
